import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { htmlEscape } from 'escape-goat';
export var MissingValueError = /*#__PURE__*/function (_Error) {
  _inherits(MissingValueError, _Error);

  var _super = _createSuper(MissingValueError);

  function MissingValueError(key) {
    var _this;

    _classCallCheck(this, MissingValueError);

    _this = _super.call(this, "Missing a value for ".concat(key ? "the placeholder: ".concat(key) : 'a placeholder'), key);
    _this.name = 'MissingValueError';
    _this.key = key;
    return _this;
  }

  return _createClass(MissingValueError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export default function pupa(template, data) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$ignoreMissing = _ref.ignoreMissing,
      ignoreMissing = _ref$ignoreMissing === void 0 ? false : _ref$ignoreMissing,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? function (_ref2) {
    var value = _ref2.value;
    return value;
  } : _ref$transform;

  if (typeof template !== 'string') {
    throw new TypeError("Expected a `string` in the first argument, got `".concat(typeof template, "`"));
  }

  if (typeof data !== 'object') {
    throw new TypeError("Expected an `object` or `Array` in the second argument, got `".concat(typeof data, "`"));
  }

  var replace = function replace(placeholder, key) {
    var value = data;

    var _iterator = _createForOfIteratorHelper(key.split('.')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var property = _step.value;
        value = value ? value[property] : undefined;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var transformedValue = transform({
      value: value,
      key: key
    });

    if (transformedValue === undefined) {
      if (ignoreMissing) {
        return placeholder;
      }

      throw new MissingValueError(key);
    }

    return String(transformedValue);
  };

  var composeHtmlEscape = function composeHtmlEscape(replacer) {
    return function () {
      return htmlEscape(replacer.apply(void 0, arguments));
    };
  }; // The regex tries to match either a number inside `{{ }}` or a valid JS identifier or key path.


  var doubleBraceRegex = /{{(\d+|[a-z$_][\w\-$]*?(?:\.[\w\-$]*?)*?)}}/gi;

  if (doubleBraceRegex.test(template)) {
    template = template.replace(doubleBraceRegex, composeHtmlEscape(replace));
  }

  var braceRegex = /{(\d+|[a-z$_][\w\-$]*?(?:\.[\w\-$]*?)*?)}/gi;
  return template.replace(braceRegex, replace);
}